package nl.astraeus.wiki.css

import kotlinx.browser.document
import nl.astraeus.css.properties.*
import nl.astraeus.css.style
import nl.astraeus.css.style.ConditionalStyle
import nl.astraeus.css.style.DescriptionProvider
import nl.astraeus.css.style.Style

class StyleDefinition(
  val materialMargin: Measurement = 1.em,
  val cardBorderRadius: Measurement = 0.3.em,
  val boxShadow: BoxShadow = BoxShadow("4px 4px 12px rgba(0, 0, 0, 0.2)"),
  val buttonBoxShadow: BoxShadow = BoxShadow("2px 2px 5px rgba(0, 0, 0, 0.1)"),
  val mainFontColor: Color = hsla(60, 50, 5, 0.75),
  val mainBackgroundColor: Color = hsl(60, 0, 95),
  //val entryFontColor: Color = hsl(Css.mainFontColorNumber, 70, 55),
  val inputBackgroundColor : Color = mainBackgroundColor.lighten(15),
  val buttonBackgroundColor : Color = mainBackgroundColor.lighten(15),
  val buttonBorderColor : Color = mainFontColor.changeAlpha(0.25),
  val buttonBorderWidth : Measurement = 1.px,
)

object NoTextSelectCls : CssName {
  override val name = "no-text-select"
}
object SelectedCls : CssName {
  override val name = "selected"
}
object ActiveCls : CssName {
  override val name = "active"
}

fun Color.hover(): Color = if (Css.currentStyle == Css.darkStyle) {
  this.lighten(15)
} else {
  this.darken(15)
}

object Css {
  var dynamicStyles = mutableMapOf<DescriptionProvider, ConditionalStyle.() -> Unit>()

  fun DescriptionProvider.defineCss(conditionalStyle: ConditionalStyle.() -> Unit) {
    check(!dynamicStyles.containsKey(this)) {
      "CssId with name ${this.description()} already defined!"
    }

    updateCss(conditionalStyle)
  }

  private fun DescriptionProvider.updateCss(conditionalStyle: ConditionalStyle.() -> Unit) {
    val elementId = this.description()
    var dynamicStyleElement = document.getElementById(elementId)

    dynamicStyles[this] = conditionalStyle

    if (dynamicStyleElement == null) {
      dynamicStyleElement = document.createElement("style")
      dynamicStyleElement.id = elementId

      document.head?.append(dynamicStyleElement)
    }

    val css = style(conditionalStyle)

    dynamicStyleElement.innerHTML = css.generateCss(minified = CssSettings.minified)
  }

  var darkStyle = StyleDefinition(
  )

  var lightStyle = StyleDefinition(
    mainBackgroundColor = hsl(239+180, 50, 15),
  )

  var currentStyle: StyleDefinition = darkStyle

  fun updateStyle() {
    for ((cssId, dynStyle) in dynamicStyles) {
      cssId.apply {
        updateCss(dynStyle)
      }
    }
  }

  fun switchLayout() {
    currentStyle = if (currentStyle == darkStyle) {
      lightStyle
    } else {
      darkStyle
    }

    updateStyle()
  }

  fun Style.transition() {
    transition("all 0.5s ease")
  }

  fun Style.noTextSelect() {
    plain("-webkit-touch-callout", "none")
    plain("-webkit-user-select", "none")
    plain("-moz-user-select", "none")
    plain("-ms-user-select", "none")

    userSelect(UserSelect.none)

    select("::selection") {
      background("none")
    }
  }
}
